import React from 'react';

const Blogs = () => {
    return (
        <div className='bg-accent h-screen pt-16'>
            <div className='text-center relative mb-16'>
                <h2 className='text-white absolute font-extrabold z-10 top-1/3 lg:left-1/3 right-1/3  text-2xl lg:text-4xl'>BLOGS</h2>
                <span className=' lg:text-8xl text-6xl opacity-40'>BLOGS</span>
            </div>
            <h2 className="text-4xl text-primary font-bold text-center">Under Construction</h2>
        </div>
    );
};

export default Blogs;